import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog'
import ContactForm from '@/components/ContactForm'

function Footer() {
  const [contactOpen, setContactOpen] = useState(false)
  return (
    <footer className="ap-gradient-dark py-16 border-t border-ap-blurple/30">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <h3 className="ap-card-title text-white">AUTHENTIPET</h3>
            <p className="ap-body-text text-white/80">
              Authentipet verifies Emotional Support Animal (ESA) letters quickly and securely. Upload your letter, get expert verification, and share a certificate with landlords or airlines.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="ap-button-text text-white">QUICK LINKS</h4>
            <div className="space-y-2">
              <Link to="/" className="block ap-body-text text-white/80 hover:text-ap-blurple transition-colors">Home</Link>
              <Link to="/how-it-works" className="block ap-body-text text-white/80 hover:text-ap-blurple transition-colors">How It Works</Link>
              <Link to="/pricing" className="block ap-body-text text-white/80 hover:text-ap-blurple transition-colors">Pricing</Link>
              <Link to="/careers" className="block ap-body-text text-white/80 hover:text-ap-blurple transition-colors">Careers</Link>
              <Link to="/locations" className="block ap-body-text text-white/80 hover:text-ap-blurple transition-colors">Locations</Link>
              <Link to="/faq" className="block ap-body-text text-white/80 hover:text-ap-blurple transition-colors">FAQ</Link>
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="ap-button-text text-white">FOR LANDLORDS</h4>
            <div className="space-y-2">
              <Link to="/property-managers" className="block ap-body-text text-white/80 hover:text-ap-blurple transition-colors">Property Managers</Link>
              <Link to="/about" className="block ap-body-text text-white/80 hover:text-ap-blurple transition-colors">About Us</Link>
              <Link to="/resources" className="block ap-body-text text-white/80 hover:text-ap-blurple transition-colors">Resources</Link>
              <Link to="/faq" className="block ap-body-text text-white/80 hover:text-ap-blurple transition-colors">FAQ</Link>
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="ap-button-text text-white">CONTACT</h4>
            <div className="space-y-3">
              <p className="ap-body-text text-white/80">
                Got questions? We'd love to hear from you!
              </p>
              <Button
                onClick={() => setContactOpen(true)}
                className="bg-ap-blurple hover:bg-ap-blurple/90 text-white ap-button-text w-full"
              >
                Contact Us
              </Button>
            </div>
          </div>
        </div>

        <div className="border-t border-ap-blurple/30 mt-12 pt-8 text-center">
          <p className="ap-body-text text-white/60">
            © 2025 Authentipet. All rights reserved. | Privacy Policy | Terms of Service | <a href="/sitemap-index.xml" className="hover:text-ap-blurple transition-colors">Sitemap</a>
          </p>
        </div>
      </div>

      {/* Contact Form Dialog */}
      <Dialog open={contactOpen} onOpenChange={setContactOpen}>
        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
          <DialogHeader className="sr-only">
            <DialogTitle>Contact Us</DialogTitle>
            <DialogDescription>Send us a message and we'll get back to you soon.</DialogDescription>
          </DialogHeader>
          <ContactForm open={contactOpen} onOpenChange={setContactOpen} />
        </DialogContent>
      </Dialog>
    </footer>
  )
}

export default Footer

